import { SxProps, Theme } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs, { TabsOwnProps } from '@mui/material/Tabs';
import { useMemo } from 'react';

import { navigationTabsStyles as sx } from './NavigationTabs.styles';

export type NavigationTab = {
	id: string;
	title: string;
	hidden?: boolean;
	customSx?: SxProps<Theme>;
};

type Props = {
	value: number;
	tabs: NavigationTab[];
	orientation?: TabsOwnProps['orientation'];
	onChange: TabsOwnProps['onChange'];
	customSx?: {
		tabs?: SxProps<Theme>;
	};
};

export const NavigationTabs = ({
	value,
	tabs,
	orientation = 'vertical',
	onChange,
	customSx
}: Props) => {
	const lValue = useMemo(() => {
		const totalTabs = tabs.filter(t => !t.hidden).length - 1;
		return value > totalTabs ? totalTabs : value;
	}, [tabs, value]);

	return (
		<Tabs
			value={lValue}
			onChange={onChange}
			orientation={orientation}
			variant='scrollable'
			scrollButtons='auto'
			allowScrollButtonsMobile
			sx={[sx.tabs, customSx?.tabs ?? false] as SxProps<Theme>}
		>
			{tabs.map(({ id, title, hidden, customSx }) =>
				!hidden ? (
					<Tab
						key={id}
						sx={[sx.tabLink, customSx ?? false] as SxProps<Theme>}
						label={title}
						disableFocusRipple
						disableRipple
						disableTouchRipple
					/>
				) : null
			)}
		</Tabs>
	);
};
